import React from 'react';
import { useNavigate } from 'react-router';
import { zxyRegisterSchema } from '../../../../../common/src/domain/zxyExchange/zxyRegisterSchema';
import { useTranslate } from '../../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelSection,
    Panel,
    PanelBody,
    PanelButton,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../../elements';
import {
    ValidatingEditPanelSaveButton,
    ValidatingEditPanelSwitch,
    ValidatingForm,
    ValidatingFormContext,
    ValidatingFormInputText,
} from '../../validatingElements';

export function RegistrationAddEdit(props: { params: { id?: string; key?: string } }) {
    const translate = useTranslate();
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/require-await
    async function handleSavedOrCancelled() {
        navigate('/settings/registrations');
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    {(props.params.id && <TopbarCrumbActive title="Edit registration" icon="fa-cogs" />) || (
                        <TopbarCrumbActive title="Add registration" icon="fa-cogs" />
                    )}
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small>
                        <PanelBody noPadding>
                            <ValidatingForm
                                schema={zxyRegisterSchema}
                                createUrl={'/api/registrations/'}
                                updateUrl={`/api/registrations/${props.params.key}`}
                                itemUrl={`/api/registrations/${props.params.id}`}
                                id={props.params.id}
                                onSubmitted={handleSavedOrCancelled}
                            >
                                <EditPanel>
                                    <EditPanelSection>
                                        <ValidatingFormInputText name="name" topLabel={translate('common.name')} />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isZxyCloudClient"
                                            placeholder="Is a ZXY Cloud client"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingFormInputText name="apiPath" topLabel="Api path. Example: 'api/zxyDataExchange/v1'" />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingFormContext.Consumer>
                                            {(state) =>
                                                state.item.hostname && (
                                                    <span className="fs12 fw200 ml10">
                                                        https://{state.item.hostname}
                                                        {state.item.apiPath !== 'undefined' ? `/${state.item.apiPath}` : ''}
                                                    </span>
                                                )
                                            }
                                        </ValidatingFormContext.Consumer>
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedReadObjectList"
                                            placeholder="Allowing listing available objects"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedReadSurveyList"
                                            placeholder="Allowing listing available surveys"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedReadObjectData"
                                            placeholder="Allow reading object data"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedReadSurveyData"
                                            placeholder="Allow reading survey data"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedUpdateObject"
                                            placeholder="Allow updating object"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedAddObject"
                                            placeholder="Allow adding object"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                    <EditPanelSection>
                                        <ValidatingEditPanelSwitch
                                            name="isAllowedAddSurvey"
                                            placeholder="Allow adding survey"
                                            onText="On"
                                            offText="Off"
                                        />
                                    </EditPanelSection>
                                </EditPanel>
                                <EditPanelButtons footer>
                                    <PanelButton text={translate('common.cancel')} onClick={handleSavedOrCancelled} />
                                    <ValidatingEditPanelSaveButton />
                                </EditPanelButtons>
                            </ValidatingForm>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
